export default __webpack_public_path__ + "static/media/md.c243e069.svg";